import type { TokensConfigV2, UiDefaultsV2, ComponentsConfigV2 } from '../ui/uiConfig';

const isPlainObject = (v: unknown): v is Record<string, unknown> =>
  v != null && typeof v === 'object' && !Array.isArray(v);

export const safe = (v?: string | null): string =>
  typeof v === 'string' && v.trim() ? v.trim() : '';

export const mergeTokens = (
  base: TokensConfigV2 | undefined,
  incoming: TokensConfigV2 | undefined
): TokensConfigV2 | undefined => {
  if (!base && !incoming) return undefined;
  return {
    ...(base ?? {}),
    ...(incoming ?? {}),
    radius: { ...(base?.radius ?? {}), ...(incoming?.radius ?? {}) },
    space: { ...(base?.space ?? {}), ...(incoming?.space ?? {}) },
    shadow: { ...(base?.shadow ?? {}), ...(incoming?.shadow ?? {}) },
    transition: { ...(base?.transition ?? {}), ...(incoming?.transition ?? {}) },
  } as TokensConfigV2;
};

export const mergeUiDefaults = (
  base: UiDefaultsV2 | undefined,
  incoming: UiDefaultsV2 | undefined
): UiDefaultsV2 | undefined => {
  if (!base && !incoming) return undefined;
  const out: Record<string, unknown> = { ...(base ?? {}), ...(incoming ?? {}) };
  for (const k of Object.keys(out)) {
    if (isPlainObject((base as Record<string, unknown>)?.[k]) ||
        isPlainObject((incoming as Record<string, unknown>)?.[k])) {
      out[k] = {
        ...((base as Record<string, unknown>)?.[k] ?? {}),
        ...((incoming as Record<string, unknown>)?.[k] ?? {}),
      };
    }
  }
  return out as UiDefaultsV2;
};

const mergeComponent = (base: unknown, incoming: unknown): unknown => {
  if (!base && !incoming) return undefined;
  const b = (base ?? {}) as Record<string, unknown>;
  const i = (incoming ?? {}) as Record<string, unknown>;
  return {
    ...b,
    ...i,
    styles: { ...(b.styles as object ?? {}), ...(i.styles as object ?? {}) },
  };
};

export const mergeComponents = (
  base: ComponentsConfigV2 | undefined,
  incoming: ComponentsConfigV2 | undefined
): ComponentsConfigV2 => {
  const b = (base ?? {}) as Record<string, unknown>;
  const i = (incoming ?? {}) as Record<string, unknown>;
  const keys = new Set([...Object.keys(b), ...Object.keys(i)]);
  const out: Record<string, unknown> = {};
  for (const k of keys) out[k] = mergeComponent(b[k], i[k]);
  return out as ComponentsConfigV2;
};
